<template>
  <svg
    width="295"
    height="265"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#a)">
      <path
        d="m0 205.911 20.721-26.712 127.491 50.838V265L0 205.911Z"
        fill="url(#b)"
        :class="c('floor', {locked: step < 5})"
      />
      <path
        d="m295 205.911-20.736-26.712-126.051 50.838V265L295 205.911Z"
        fill="#BD883A"
        :class="c('floor', {locked: step < 5})"
      />
      <path
        d="m148.213 147.804-127.491 31.41 127.491 50.823 126.051-50.823-126.051-31.41Z"
        fill="#916120"
        :class="c('floor', {locked: step < 5, top: true})"
      />
      <path
        d="m22.429 175.185 20.736-26.712 105.048 41.771v34.962L22.429 175.185Z"
        fill="url(#c)"
        :class="c('floor', {locked: step < 4})"
      />
      <path
        d="m273.195 175.185-20.721-26.712-104.261 41.771v34.962l124.982-50.021Z"
        fill="#BD883A"
        :class="c('floor', {locked: step < 4})"
      />
      <path
        d="M148.213 108.01 43.165 148.487l105.048 41.756 104.26-41.756-104.26-40.477Z"
        fill="#916120"
        :class="c('floor', {locked: step < 4, top: true})"
      />
      <path
        d="m44.397 144.295 20.736-26.712 83.079 32.971v34.962L44.397 144.295Z"
        fill="url(#d)"
        :class="c('floor', {locked: step < 3})"
      />
      <path
        d="m251.523 144.295-20.722-26.712-82.589 32.971v34.962l103.311-41.221Z"
        fill="#BD883A"
        :class="c('floor', {locked: step < 3})"
      />
      <path
        d="m148.212 86.59-83.094 31.008 83.094 32.956 82.589-32.956-82.589-31.009Z"
        fill="#916120"
        :class="c('floor', {locked: step < 3, top: true})"
      />
      <path
        d="M66.35 113.153 87.088 86.44l61.126 24.349v34.978l-81.862-32.614Z"
        fill="url(#e)"
        :class="c('floor', {locked: step < 2})"
      />
      <path
        d="M230.06 113.153 209.338 86.44l-61.125 24.349v34.978l81.847-32.614Z"
        fill="#BD883A"
        :class="c('floor', {locked: step < 2})"
      />
      <path
        d="m148.213 62.136-61.126 24.32 61.126 24.333 61.125-24.334-61.125-24.319Z"
        fill="#916120"
        :class="c('floor', {locked: step < 2, top: true})"
      />
      <path
        d="m88.557 82.219 20.721-26.713 38.935 15.505v34.977l-59.656-23.77Z"
        fill="url(#f)"
        :class="c('floor', {locked: step < 1})"
      />
      <path
        d="m208.448 81.996-20.737-26.713-39.498 15.728v34.977l60.235-23.992Z"
        fill="#BD883A"
        :class="c('floor', {locked: step < 1})"
      />
      <path
        d="M148.213 43.08 109.278 55.52l38.935 15.49 39.498-15.713-39.498-12.219Z"
        fill="#916120"
        :class="c('floor', {locked: step < 1, top: true})"
      />
      <path
        d="m110.392 50.839 20.721-26.713L148.213 0v65.912l-37.821-15.073Z"
        fill="url(#g)"
      />
      <path
        d="M187.222 50.363 166.485 23.65 148.213 0v65.912l39.009-15.55Z"
        fill="#BD883A"
      />
      <path
        d="M155.62 35.557c.801-.312 1.618-.267 2.434.12.816.4 1.633 1.173 2.434 2.333.802 1.16 1.648 2.884 2.524 5.173.875 2.319 1.41 4.177 1.573 5.59.163 1.411.104 2.526-.223 3.344-.311.818-.875 1.382-1.707 1.71-.831.326-1.632.297-2.434-.09-.801-.386-1.588-1.144-2.39-2.26-.786-1.114-1.633-2.824-2.493-5.113-1.218-3.196-1.797-5.649-1.722-7.328.089-1.858.757-3.018 1.989-3.508l.015.03Zm1.246 3.137c-.356.133-.593.446-.742.906-.133.461-.104 1.16.074 2.096.193.937.609 2.245 1.247 3.94.846 2.2 1.589 3.656 2.242 4.37s1.247.966 1.766.758c.505-.193.757-.758.757-1.665 0-1.1-.43-2.794-1.306-5.054-.876-2.29-1.648-3.805-2.301-4.549-.653-.743-1.247-1.01-1.766-.802h.029ZM162.625 33.313l3.132-1.234 6.65 17.437-2.078.817-5.462-14.315-2.271.892.029-3.597ZM166.951 70.542c.787-.312 1.573-.268 2.375.119.801.386 1.588 1.144 2.375 2.289.787 1.13 1.603 2.824 2.464 5.054.861 2.26 1.38 4.088 1.544 5.47.163 1.383.104 2.468-.208 3.27-.312.803-.861 1.353-1.677 1.666-.817.312-1.604.282-2.375-.09-.772-.371-1.559-1.114-2.331-2.2-.772-1.085-1.588-2.75-2.434-4.994-1.188-3.122-1.752-5.515-1.678-7.165.09-1.814.743-2.958 1.945-3.42Zm1.217 3.062c-.341.134-.579.431-.712.892-.134.46-.104 1.145.074 2.051.178.907.594 2.2 1.217 3.85.816 2.156 1.544 3.583 2.182 4.281.638.7 1.217.937 1.722.744.49-.194.742-.743.742-1.635 0-1.086-.43-2.736-1.262-4.936-.861-2.244-1.603-3.716-2.241-4.444-.638-.729-1.217-.981-1.722-.788v-.015ZM176.05 73.797l-1.989.773c-.653-1.858-.831-3.448-.564-4.771.268-1.324.936-2.186 1.989-2.602a2.667 2.667 0 0 1 1.975-.015c.668.238 1.306.714 1.914 1.412a7.851 7.851 0 0 1 1.411 2.334c.385 1.011.623 2.17.697 3.479.089 1.308-.059 2.943-.415 4.905l-.431 2.498 3.83-1.502 1.143 3.003-7.452 2.913-.594-1.56 1.277-6.675c.312-1.605.445-2.854.416-3.731-.03-.892-.178-1.65-.416-2.274-.252-.654-.594-1.145-1.039-1.472-.445-.327-.876-.401-1.306-.223-.431.178-.713.58-.802 1.204-.089.625.015 1.398.342 2.29l.014.014ZM176.966 105.463c.787-.312 1.573-.267 2.375.119.801.387 1.588 1.145 2.375 2.289.786 1.13 1.603 2.825 2.464 5.054.861 2.26 1.38 4.088 1.543 5.471.164 1.382.09 2.467-.207 3.27-.312.803-.861 1.353-1.678 1.665-.816.312-1.603.282-2.375-.089-.771-.372-1.543-1.115-2.33-2.2-.772-1.085-1.588-2.75-2.449-4.995-1.188-3.122-1.752-5.515-1.678-7.15.09-1.814.743-2.958 1.945-3.419l.015-.015Zm1.217 3.062c-.341.134-.579.432-.713.892-.133.461-.103 1.145.075 2.052.193.906.593 2.2 1.217 3.85.816 2.155 1.544 3.582 2.182 4.281.638.699 1.217.936 1.722.743.49-.193.742-.743.742-1.635 0-1.085-.431-2.72-1.277-4.935-.861-2.245-1.603-3.716-2.241-4.445-.638-.728-1.217-.981-1.722-.788l.015-.015ZM185.798 107.336l-1.959.773c-.371-1.308-.475-2.423-.297-3.374.252-1.323.861-2.17 1.855-2.557.876-.342 1.796-.193 2.732.461.935.654 1.632 1.59 2.092 2.809.282.759.416 1.502.401 2.23-.029.729-.208 1.383-.564 1.962.772.06 1.485.387 2.152 1.026.668.624 1.188 1.457 1.589 2.497.579 1.532.727 2.959.415 4.296-.311 1.338-1.009 2.23-2.107 2.661-1.039.402-2.079.238-3.118-.505-1.039-.743-1.914-1.962-2.642-3.657l2.019-.788c.416.847.861 1.427 1.336 1.739.46.313.92.372 1.38.194.475-.194.787-.58.906-1.19.133-.609.059-1.263-.208-1.962-.297-.773-.757-1.338-1.38-1.709-.624-.372-1.336-.402-2.153-.104l-1.054-2.78c.461-.253.787-.52.965-.788.178-.282.267-.595.282-.966 0-.372-.044-.729-.178-1.085-.178-.461-.43-.803-.742-1.026-.327-.223-.638-.268-.98-.134-.297.119-.504.357-.638.729-.134.371-.148.802-.074 1.293l-.03-.045ZM188.951 141.4c.787-.312 1.573-.268 2.375.119.801.386 1.588 1.145 2.375 2.289.787 1.13 1.603 2.824 2.464 5.054.861 2.26 1.38 4.088 1.544 5.471.163 1.382.089 2.467-.208 3.27-.312.803-.861 1.353-1.677 1.665-.817.312-1.604.282-2.375-.089-.772-.372-1.559-1.115-2.331-2.2-.772-1.086-1.588-2.75-2.434-4.995-1.188-3.122-1.752-5.515-1.678-7.15.09-1.814.743-2.958 1.945-3.419v-.015Zm1.217 3.062c-.341.134-.579.431-.712.892-.134.461-.104 1.145.074 2.051.193.907.594 2.201 1.217 3.851.816 2.155 1.544 3.582 2.182 4.281.638.698 1.217.951 1.722.743.49-.193.742-.743.742-1.635 0-1.085-.43-2.721-1.276-4.935-.861-2.245-1.604-3.717-2.242-4.445-.638-.728-1.217-.996-1.722-.788l.015-.015ZM198.139 137.803l2.034-.803 4.186 10.97.964-.371 1.143 3.003-.965.371 1.336 3.493-2.004.788-1.335-3.493-4.691 1.843-1.143-3.002.475-12.799Zm4.216 10.955-2.182-5.708-.282 6.675 2.449-.967h.015ZM202.951 174.754c.787-.312 1.573-.268 2.375.119.801.386 1.588 1.145 2.375 2.289.787 1.13 1.603 2.824 2.464 5.054.861 2.26 1.38 4.088 1.544 5.471.163 1.382.089 2.467-.208 3.27-.312.803-.861 1.353-1.677 1.665a2.882 2.882 0 0 1-2.375-.089c-.772-.372-1.559-1.115-2.331-2.2-.772-1.086-1.588-2.75-2.434-4.995-1.188-3.122-1.752-5.515-1.678-7.15.09-1.814.743-2.958 1.945-3.419v-.015Zm1.217 3.062c-.341.134-.579.431-.712.892-.134.461-.104 1.145.074 2.051.178.907.594 2.201 1.217 3.851.816 2.155 1.544 3.582 2.182 4.281.638.698 1.217.951 1.722.743.49-.193.742-.743.742-1.635 0-1.085-.43-2.721-1.276-4.935-.847-2.245-1.604-3.717-2.242-4.445-.638-.728-1.217-.981-1.722-.788l.015-.015ZM209.838 172.554l5.032-1.977 1.143 3.003-3.503 1.367.742 3.271c.104-.104.208-.194.312-.253.104-.074.207-.134.326-.179.98-.386 1.989-.178 3.028.625 1.054.803 1.885 2.021 2.509 3.671.638 1.665.816 3.196.534 4.624-.282 1.412-.935 2.318-1.959 2.72-.92.357-1.856.253-2.835-.312-.98-.565-1.841-1.531-2.583-2.884l2.152-.847c.371.46.742.787 1.114.951.371.163.727.193 1.053.059.446-.178.743-.579.861-1.233.119-.64.03-1.368-.282-2.186-.297-.787-.697-1.382-1.187-1.769-.49-.386-.935-.505-1.366-.341-.222.089-.415.267-.564.52-.148.267-.267.609-.341 1.055l-1.885.06-2.301-9.975v.03ZM216.596 209.345c.787-.312 1.574-.268 2.375.119.802.386 1.589 1.145 2.39 2.289.787 1.13 1.603 2.825 2.464 5.054.861 2.26 1.381 4.088 1.544 5.471.163 1.382.089 2.467-.208 3.27-.312.803-.861 1.353-1.677 1.665a2.882 2.882 0 0 1-2.375-.089c-.772-.372-1.559-1.115-2.331-2.2-.771-1.086-1.588-2.75-2.449-4.995-1.187-3.122-1.751-5.515-1.677-7.15.089-1.814.742-2.958 1.944-3.419v-.015Zm1.218 3.062c-.342.134-.579.431-.713.892-.133.461-.104 1.145.074 2.052.193.906.594 2.2 1.218 3.85.816 2.155 1.543 3.582 2.182 4.281.638.698 1.217.951 1.721.743.49-.193.743-.743.743-1.635 0-1.085-.431-2.72-1.277-4.935-.846-2.245-1.603-3.717-2.241-4.445-.639-.728-1.218-.996-1.722-.788l.015-.015ZM225.161 205.986l2.271.698.327 6.526c.905-.357 1.885-.149 2.909.639 1.039.788 1.841 1.947 2.434 3.479.564 1.486.713 2.869.461 4.147-.268 1.293-.861 2.111-1.782 2.468-.965.386-1.974.163-3.028-.654-1.054-.818-1.84-1.918-2.375-3.301a9.62 9.62 0 0 1-.46-1.65c-.104-.564-.178-1.486-.252-2.72l-.505-9.662v.03Zm3.652 10.346c-.386.148-.624.49-.713 1.025-.089.535 0 1.13.238 1.784.252.654.593 1.16 1.039 1.502.445.341.846.445 1.202.297.386-.149.623-.491.727-1.041.104-.55.03-1.159-.222-1.828-.253-.654-.594-1.145-1.025-1.487-.43-.327-.846-.416-1.246-.267v.015Z"
        fill="#fff"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1="91.184"
        y1="201.377"
        x2="70.979"
        y2="241.579"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1B445" />
        <stop
          offset="1"
          stop-color="#BD883A"
        />
      </linearGradient>
      <linearGradient
        id="c"
        x1="101.96"
        y1="166.995"
        x2="82.634"
        y2="205.428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1B445" />
        <stop
          offset="1"
          stop-color="#BD883A"
        />
      </linearGradient>
      <linearGradient
        id="d"
        x1="112.484"
        y1="132.597"
        x2="94.065"
        y2="169.247"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1B445" />
        <stop
          offset="1"
          stop-color="#BD883A"
        />
      </linearGradient>
      <linearGradient
        id="e"
        x1="122.993"
        y1="98.109"
        x2="105.542"
        y2="132.844"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1B445" />
        <stop
          offset="1"
          stop-color="#BD883A"
        />
      </linearGradient>
      <linearGradient
        id="f"
        x1="133.622"
        y1="63.682"
        x2="117.107"
        y2="96.559"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1B445" />
        <stop
          offset="1"
          stop-color="#BD883A"
        />
      </linearGradient>
      <linearGradient
        id="g"
        x1="149.386"
        y1="18.284"
        x2="132.38"
        y2="52.127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1B445" />
        <stop
          offset="1"
          stop-color="#BD883A"
        />
      </linearGradient>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M0 0h295v265H0z"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
import {cn} from '@/app/js/classname'

const c = cn('pyramid')

export default {
  name: 'SurveyPyramid',
  props: {
    step: {
      type: Number,
      default: 0
    }
  },
  methods: {
    c
  }
}
</script>

<style lang="scss">
.pyramid {
  &__floor {
    &_top {
      fill: #916120;
    }

    &_locked {
      fill-opacity: 0.5;
    }

    &_locked + &_top {
      fill: #fff;
    }
  }
}
</style>
